import { StoreEnum } from '@portal/schema/storeCode';

// Move to Sanity
export const EMPTY_STATE_SHOP_LINK = '/shop';
export const PROGRESS_BAR_LINK = '/shop';
export const MAX_PROGRESS_BAR_VALUE = 200;

export const CADENCE_OPTIONS: { [key in StoreEnum]: { value: string; label: string }[] } = {
  [StoreEnum.us]: [
    { value: 'gid://shopify/SellingPlan/2565374050', label: 'Every 30 Days' },
    { value: 'gid://shopify/SellingPlan/2996764770', label: 'Every 45 Days' },
    { value: 'gid://shopify/SellingPlan/2988114018', label: 'Every 60 Days' }
  ],
  [StoreEnum.eu]: [{ value: 'gid://shopify/SellingPlan/689745461588', label: 'Every 30 Days' }],
  [StoreEnum.uk]: [{ value: 'gid://shopify/SellingPlan/4239229005', label: 'Every 30 Days' }],
  [StoreEnum.au]: [
    { value: 'gid://shopify/SellingPlan/2565374050', label: 'Every 30 Days' },
    { value: 'gid://shopify/SellingPlan/2996764770', label: 'Every 45 Days' },
    { value: 'gid://shopify/SellingPlan/2988114018', label: 'Every 60 Days' }
  ],
  [StoreEnum.nz]: [
    { value: 'gid://shopify/SellingPlan/2565374050', label: 'Every 30 Days' },
    { value: 'gid://shopify/SellingPlan/2996764770', label: 'Every 45 Days' },
    { value: 'gid://shopify/SellingPlan/2988114018', label: 'Every 60 Days' }
  ],
  [StoreEnum.qa]: [
    { value: 'gid://shopify/SellingPlan/1591246891', label: 'Every 30 Days' },
    { value: 'gid://shopify/SellingPlan/6685851691', label: 'Every 45 Days' },
    { value: 'gid://shopify/SellingPlan/6678446123', label: 'Every 60 Days' }
  ],
  [StoreEnum.dev]: [],
  [StoreEnum.aud]: [
    { value: 'gid://shopify/SellingPlan/1591246891', label: 'Every 30 Days' },
    { value: 'gid://shopify/SellingPlan/6685851691', label: 'Every 45 Days' },
    { value: 'gid://shopify/SellingPlan/6678446123', label: 'Every 60 Days' }
  ],
  [StoreEnum.nzd]: [
    { value: 'gid://shopify/SellingPlan/1591246891', label: 'Every 30 Days' },
    { value: 'gid://shopify/SellingPlan/6685851691', label: 'Every 45 Days' },
    { value: 'gid://shopify/SellingPlan/6678446123', label: 'Every 60 Days' }
  ],
  [StoreEnum.jp]: [],
  [StoreEnum.eud]: [{ value: 'gid://shopify/SellingPlan/690651464049', label: 'Every 30 Days' }],
  [StoreEnum.ukd]: []
};

export type BundleItemType = {
  id: string;
  title: string;
  quantity: number;
  image: string;
  price: number;
  originalPrice: number;
};

const createBundleItem = ({
  id,
  title,
  quantity,
  image,
  price,
  originalPrice
}: BundleItemType): BundleItemType => ({
  id,
  title,
  quantity,
  image,
  price,
  originalPrice
});

export const BUNDLE_ITEMS = [
  createBundleItem({
    id: '41592090034274',
    title: 'Travel Pack (5 ct)',
    quantity: 1,
    image:
      'https://cdn.shopify.com/s/files/1/0559/1298/8715/files/TP_5ct_original-1x1-11_13_2024.png?v=1731605827',
    price: 0,
    originalPrice: 19
  }),
  createBundleItem({
    id: '41592090067042',
    title: 'Travel Pack (5 ct)',
    quantity: 1,
    image:
      'https://cdn.shopify.com/s/files/1/0559/1298/8715/files/TP_5ct_tropical-1x1-11_13_2024.png?v=1731605848',
    price: 0,
    originalPrice: 19
  }),
  createBundleItem({
    id: '3',
    title: 'Canister',
    quantity: 1,
    image:
      'https://cdn.shopify.com/s/files/1/0559/1298/8715/files/canister-1x1-11_13_2024.png?v=1731604355',
    price: 0,
    originalPrice: 14
  }),
  createBundleItem({
    id: '4',
    title: 'Shaker',
    quantity: 2,
    image:
      'https://cdn.shopify.com/s/files/1/0559/1298/8715/files/shaker_single-1x1-11_13_2024.png?v=1731604847',
    price: 0,
    originalPrice: 28
  })
];

export const NO_CADENCE_KEY = 'no-cadence';

// Omega subscribe and save pricing
export const OMEGA_SUBSCRIBE_AND_SAVE_PRICE = 4;
export const OMEGA_SUBSCRIBE_AND_SAVE_BUNDLE_PRICE = 10;
